export default "__VITE_ASSET__BVKYkAMg__"